<template>
    <header class="main-header">
        <div class="container">
            <nav class="navbar navbar-expand-lg main-nav px-0">
              <a class="navbar-brand" @click="onChangeRoute('main', $event)"><img src="@/assets/image/logo.png"/></a>

              <button class="navbar-toggler" 
                type="button" 
                data-bs-toggle="collapse" 
                data-bs-target="#mainMenu" 
                aria-bs-controls="mainMenu" 
                aria-bs-expanded="false" 
                aria-bs-label="Toggle navigation">
                <span class="icon-bar icon-bar-1"></span>
                <span class="icon-bar icon-bar-2"></span>
                <span class="icon-bar icon-bar-3"></span>
              </button>

              <div class="collapse navbar-collapse" id="mainMenu">
                  <ul class="navbar-nav ml-auto text-uppercase f1">
                      <li v-for="(item, index) in navbar" :key="index">
                        <a @click="onChangeRoute(item.routeName, $event)" key="index"
                          :class="{
                            'active': currNav == item.routeName 
                          }">{{item.name}}</a>
                      </li>
                  </ul>
              </div>
            </nav>
        </div>
    </header>
</template>

<script>
  export default {
    name: 'BaseHeader',
    components: {
      
    },
    data() {
      return {   
        currNav: 'main', 
        navbar: [
          {
            name: 'Home', 
            routeName: 'main'
          },
          {
            name: '대화형 AI', 
            routeName: 'conversationalAi'
          },
          {
            name: 'AICC', 
            routeName: 'aicc'
          },
          {
            name: '문의하기', 
            routeName: 'contact'
          },
        ]
      }
    },
    computed: {},
    watch: {
      $route(current) {
        this.onActiveNav(current.name); 
      }
    },
    created(){},
    mounted(){},
    beforeDestroy() {},
    methods: {
      onChangeRoute(routeName, event) {
        if(this.currNav === routeName) return; 
        
        event.preventDefault();
        console.log("routeName:", routeName); 

        if(routeName === 'contact') { 
          window.open("https://www.bespinglobal.com/contact/", "_blank");
          return; 
        }

        this.$router.push({name: routeName}); 
        this.onActiveNav(routeName); 

        window.scrollTo(0, 0); 
      }, 
      onActiveNav(routeName) {
        this.currNav = routeName; 
      }
    }
  }
</script>

<style lang="scss" scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/BaseHeader.vue